import { Component, Input } from '@angular/core';


import { Badge } from './entities/badge.entity';

export { Badge, BadgeType } from './entities/badge.entity';

@Component({
    standalone: true,
    selector: 'sh-badge',
    templateUrl: './badge.component.html',
    imports: []
})
export class ShBadgeComponent {
    @Input() badge!: Badge;

    get badgeCount(): string | undefined {
        if (this.badge && this.badge.count > 0) {
            return this.badge.count >= 100 ? '99+' : `${this.badge.count}`;
        }
        return undefined;
    }
}
